import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export const authenticationInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const token: string | null = sessionStorage.getItem('CSRF-TOKEN');
  const isStateMutating: boolean = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(request.method);

  const authenticatedRequest = request.clone({
    withCredentials: true,
    headers: token && isStateMutating
      ? request.headers.set('X-CSRF-TOKEN', token)
      : request.headers
  });

  return next(authenticatedRequest).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        const csrfToken: string | null = event.headers.get('X-CSRF-TOKEN');
        if (csrfToken) {
          sessionStorage.setItem('CSRF-TOKEN', csrfToken);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        window.location.replace(environment.unauthenticatedUrl());
        return EMPTY;
      }
      return throwError(() => error);
    })
  );
};
